import React, { FC } from 'react';

import { Navigate } from 'react-router-dom';

import useRoutes from 'hooks/use-routes';
import { useFlag } from 'state/launchdarkly';
import { useLocationContext } from 'state/location';
import { useStoreContext } from 'state/store';
import { findStoreNumberInUrl } from 'state/store/hooks';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

// Ensures that a store is selected before rendering children
const StoreSelected: FC = ({ children }) => {
  const { noStoreSelected } = useStoreContext();
  const { location, setStoreLocatorCallbackUrl } = useLocationContext();
  const { getLocalizedRouteForPath } = useRoutes();
  const enableStaticMenu = useFlag(LaunchDarklyFlag.ENABLE_STATIC_MENU);
  const storeNumberInUrl = findStoreNumberInUrl(location.search);

  // if enableStaticMenu is true, allow menu to be seen with no store selected
  if (noStoreSelected && !enableStaticMenu && !storeNumberInUrl) {
    setStoreLocatorCallbackUrl(`${location.pathname}${location.search}`);
    return <Navigate to={getLocalizedRouteForPath('store-locator')} />;
  }

  return <>{children}</>;
};

export default StoreSelected;
